import { Location } from '@angular/common';
import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject, filter, Subscription } from 'rxjs';
import { getWindow } from 'ssr-window';

export interface StepItems {
  key: string;
  path: string;
  label: string;
  isComplited: boolean
}

@Component({
  selector: 'stepper',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.scss']
})
export class StepperComponent implements OnInit, OnDestroy {

  @Input() ownCheckout = false;
  @Input() proxyService = null;
  @Input() mainName = 'onboarding';
  @Input() backUrl = null;
  @Input() showStepSummary = false;
  @Input() isDisableStep = false;
  steps: any[] = [];
  currentUrl: string = '';
  currentStep = null;
  stepInProgress$ = new BehaviorSubject<boolean>(false) 
  private runCheckAfterInit = false;
  private routeChangeSub: Subscription = new Subscription();
  private stepsStateSub: Subscription = new Subscription();
  private currentStepSub: Subscription = new Subscription();

  constructor(private router: Router, private location: Location) {
    this.routeChangeSub = this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
    ).subscribe((event: any) => {
      this.currentUrl = event.urlAfterRedirects;
      if (this.steps && this.steps.length) {
        this.setCurrentStep();
      } else {
        this.runCheckAfterInit = true; // remove if previous behavoir will be needed
      }
    });
  }

  ngOnInit(): void {
    if (this.proxyService.stepInProgress$) {
      this.stepInProgress$ = this.proxyService.stepInProgress$;
    }
    
    const stapperEl = document.querySelector("#stapper");
    if (stapperEl) {
      const observer = new IntersectionObserver( 
        ([e]) => setTimeout(() => e.target.classList.toggle("is-sticky", e.intersectionRatio < 1), 500),
        { threshold: [1] }
      );
      observer.observe(stapperEl);
    }
    
    this.stepsStateSub = this.proxyService.stepsState$.pipe(filter(vals => !!vals)).subscribe(steps => {
      this.steps = steps;
      if (this.runCheckAfterInit && this.steps && this.steps.length) {
        this.setCurrentStep();
        this.runCheckAfterInit = false;
      }
    });
    
    this.currentStepSub = this.proxyService.currentStep$.subscribe(step => {
      if (this.currentStep === null && step !== null) { 
        this.currentStep = step;
      }
      setTimeout(() => {
        const errorElement = document.querySelectorAll(".is-active");
        if (errorElement && errorElement[0]) {
          errorElement[0].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' })
        }
      });
      if (step !== this.currentStep) {
        getWindow().scrollTo({ top: 0, behavior: 'smooth' });
        this.router.navigate([this.mainName + '/' + this.steps[step].path], { queryParamsHandling: "merge" });
      }
    });
  }

  checknGo(step: any) {
    if(!this.ownCheckout)
      return;
      if (step.isComplited && !this.currentUrl.includes(step.path)) {
        this.router.navigate([this.mainName + '/' + step.path], { queryParamsHandling: "merge" });
      }
      if (!step.isComplited && !this.currentUrl.includes(step.path)) {
        if (this.steps[this.currentStep].key !== 'type' && this.steps[this.currentStep].key !== 'checkout') {
          this.proxyService.checkValidation(this.steps[this.currentStep].key);
        } else {
          this.router.navigate([this.mainName + '/' + step.path], { queryParamsHandling: "merge" });
        }
      }
  }

  nextStep() {
    if (this.isDisableStep) {
      return;
    }

    if ((this.currentStep + 1) < this.steps.length) {
      if (this.steps[this.currentStep].key !== 'type' && this.steps[this.currentStep].key !== 'checkout') {
        this.proxyService.checkValidation(this.steps[this.currentStep].key);
      } else {
        const url = this.mainName + '/' + this.steps[this.currentStep + 1].path;
        this.router.navigate([url], { queryParamsHandling: "merge" });
      }
    }
  }

  prevStep() {
    if (this.steps[this.currentStep - 1]) {
      const url = this.mainName + '/' + this.steps[this.currentStep - 1].path;
      this.router.navigate([url], { queryParamsHandling: "merge" });
    } else {
      if (this.backUrl) {
        this.router.navigate([this.backUrl.url], { queryParams: this.backUrl.queryParams});
      } else {
        this.location.back();
      }
    }
  }

  finishStep() {
    this.proxyService.checkValidation(this.steps[this.currentStep].key);
  }

  ngOnDestroy(): void {
    this.routeChangeSub.unsubscribe();
    this.stepsStateSub.unsubscribe();
    this.currentStepSub.unsubscribe();
  }

  setCurrentStep() {
    this.currentStep = this.steps.findIndex(item => this.currentUrl.includes(item.path));
    this.proxyService.setCurrentStep(this.currentStep);
  }

  getStepSummaryLabel(step: any) {
    if (!step) {
      return '';
    }

    switch (step.key) {
      case 'jobPosition':
        return 'Role';
      case 'checkout':
        return 'Summary';
      default:
        return step.label || '';
    }
  }

}
